import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-hot-toast';
import { HiMail } from 'react-icons/hi';

import { validateEmail } from '../../common/validations';

import { emailVerification } from '../../redux/actions/preRegistration';

import { Button } from '../../components/buttons/Button';
import { CopyrightFooter } from '../../components/copyrightFooter/CopyrightFooter';
import { BrandingLogo } from '../../components/brandingLogo/BrandingLogo';

export const FormPreRegistration = () => {
	const dispatch = useDispatch();
	const [focusedInput, setFocusedInput] = useState(false);
	const [emailError, setEmailError] = useState(null);
	const [formData, setFormData] = useState({
		email: '',
	});

	const {
		loading,
	} = useSelector((state) => state.preRegistration);

	const onChange = (e) => {
		const { name, value } = e.target;
		if (name === 'email') {
			setEmailError(null);
		}
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	}

	const handleEmailVarification = (e) => {
		e.preventDefault();
		const trimmed = (formData.email ?? '').trim();
		const emailValid = validateEmail(trimmed);

		if (!trimmed) {
			setEmailError('required');
			toast.error('Ingresa tu correo electrónico');
			return;
		}
		if (!emailValid) {
			setEmailError('invalid');
			toast.error('Ingresa un correo electronico valido');
			return;
		}
		setEmailError(null);
		dispatch(emailVerification(trimmed))
			.then((result) => {
				if (result.status === 200) {
					// toast.success(result.message);
				} else {
					toast.error(result.message);
				}
			});
	}

	return (
		<div className='w-full flex-1 min-h-0 h-full flex flex-col bg-white animate-fadeIn'>
			<div className='w-full max-w-md mx-auto flex flex-col flex-1 min-h-0 px-4 md:px-6'>
				<div className='flex-1 flex flex-col justify-center min-h-0 overflow-y-auto py-6'>
					<div className='flex justify-center shrink-0 mb-8 animate-slideDown'>
						<BrandingLogo />
					</div>
					<div className='flex justify-center items-center animate-slideUp' style={{ animationDelay: '0.1s' }}>
						<div className='w-full'>
							<h1 className='text-2xl font-bold text-gray-800 text-center'>
								Bienvenido a CFA
							</h1>
						</div>
					</div>
					<div className='flex justify-center items-center mt-3 animate-slideUp' style={{ animationDelay: '0.2s' }}>
						<div className='w-full'>
							<h2 className='text-sm font-normal text-gray-500 text-center'>
								Para continuar con el proceso de registro ingresa tu correo electrónico.
							</h2>
						</div>
					</div>
					<div className='mt-8 flex justify-center'>
						<form
							noValidate
							className='flex w-full flex-col items-center justify-center gap-6 animate-slideUp'
							style={{ animationDelay: '0.3s' }}
							onSubmit={(e) => handleEmailVarification(e)}
						>
							<div className='w-full'>
								<label
									htmlFor='pre-registro-email'
									className={`block text-sm font-semibold mb-2 ${emailError ? 'text-red-700' : 'text-gray-700'}`}
								>
									Correo electrónico
								</label>
								<div className='relative'>
									<div className={`absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none transition-colors duration-300 ${
										emailError ? 'text-red-500' : focusedInput ? 'text-indigo-600' : 'text-gray-400'
									}`}>
										<HiMail className='w-5 h-5' />
									</div>
									<input
										id='pre-registro-email'
										name='email'
										type='email'
										autoComplete='email'
										onChange={(e) => onChange(e)}
										onFocus={() => setFocusedInput(true)}
										onBlur={() => setFocusedInput(false)}
										value={formData.email}
										placeholder='tucorreo@ejemplo.com'
										disabled={loading}
										aria-invalid={emailError ? 'true' : 'false'}
										className={`w-full pl-12 pr-4 py-3.5 border-2 rounded-xl transition-all duration-300 outline-none
											${emailError
												? 'border-red-500 bg-red-50 text-red-900 placeholder-red-300 focus:ring-4 focus:ring-red-100'
												: focusedInput
													? 'border-indigo-600 bg-indigo-50/50 shadow-lg shadow-indigo-200/50 focus:ring-4 focus:ring-indigo-100'
													: 'border-gray-200 bg-white hover:border-gray-300 focus:ring-4 focus:ring-indigo-100'
											}
											disabled:bg-gray-50 disabled:cursor-not-allowed`}
									/>
								</div>
								{emailError === 'required' && (
									<p className='mt-2 text-sm text-red-600'>Ingresa tu correo electrónico.</p>
								)}
								{emailError === 'invalid' && (
									<p className='mt-2 text-sm text-red-600'>El formato del correo no es válido.</p>
								)}
							</div>
							<div className='w-full'>
								<Button
									type="submit"
									variant="gradient"
									fullWidth
									loading={loading}
									loadingLabel="Verificando..."
								>
									Registrarse
								</Button>
							</div>
						</form>
					</div>
					<div className='mt-6 flex justify-center animate-slideUp' style={{ animationDelay: '0.4s' }}>
						<Link to={'/'} className='text-sm'>
							<span className='text-gray-700'>¿Ya tienes una cuenta? </span>
							<span className='font-semibold text-indigo-600 hover:text-indigo-800 transition-colors duration-300 hover:underline'>Iniciar sesión</span>
						</Link>
					</div>
				</div>
				<CopyrightFooter className='flex-shrink-0 pb-6 pt-8 animate-fadeIn' style={{ animationDelay: '0.5s' }} />
			</div>

			{/* CSS Animations */}
			<style jsx>{`
				@keyframes fadeIn {
					from {
						opacity: 0;
					}
					to {
						opacity: 1;
					}
				}

				@keyframes slideDown {
					from {
						opacity: 0;
						transform: translateY(-20px);
					}
					to {
						opacity: 1;
						transform: translateY(0);
					}
				}

				@keyframes slideUp {
					from {
						opacity: 0;
						transform: translateY(20px);
					}
					to {
						opacity: 1;
						transform: translateY(0);
					}
				}

				.animate-fadeIn {
					animation: fadeIn 0.6s ease-out forwards;
				}

				.animate-slideDown {
					animation: slideDown 0.6s ease-out forwards;
				}

				.animate-slideUp {
					animation: slideUp 0.6s ease-out forwards;
					opacity: 0;
					animation-fill-mode: forwards;
				}
			`}</style>
		</div>
	);
};
